export var handleClickCommon = function handleClickCommon(event, onClick) {
  if (onClick) {
    event.preventDefault();
    event.stopPropagation();
    onClick(event);
  }
};